module.exports = __webpack_public_path__ + "static/media/xp-3.5b94f56e.png";